import { useStore } from '@/store'

export async function downloadPdf(data: string) {
    const empresa = useStore.getState().company
    const competencia = useStore.getState().competence.format('YYYY-MM')

    // Generate a base filename
    let filename = ''
    if (empresa) {
        filename = empresa.nomeFantasia
            .replace(' ', '-')
            .replace(/[^a-zA-Z0-9]/g, '')
            .toLowerCase()
    } else {
        filename = Date.now().toString().slice(0, 10)
    }

    const fullFilename = `espelho-ponto-${filename}-${competencia}.pdf`

    const byteCharacters = atob(data)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: 'application/pdf' })

    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fullFilename
    link.click()

    setTimeout(() => URL.revokeObjectURL(url), 100)
}
